/**
 * Csv Schema of Motorista
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'

/* TODO: review generated schema */
export class CsvMotoristaSchema extends Schema {
  readonly name = 'CsvMotorista'

  readonly fieldSet: FieldSet<Motorista> = {
    idMotoristaPk: schema => schema.model.idMotoristaPk,
    nome: schema => schema.model.nome?.toUpperCase() ?? '',
    cpf: schema => Helper.cpf(schema.model.cpf),
    rg: schema => Helper.rg(schema.model.rg),
    celular: schema => Helper.phone(schema.model.celular),
    placaVeiculo: schema => schema.model.placaVeiculo?.toUpperCase() ?? '',
    marcaVeiculo: schema => schema.model.marcaVeiculo,
    dataNascimento: schema => Helper.datetime(schema.model.dataNascimento),
    email: schema => schema.model.email?.toUpperCase() ?? '',
    tipoVeiculo: schema => schema.model.tipoVeiculo,
    tipoCarreta: schema => schema.model.tipoCarreta,
    tipoCarroceria: schema => schema.model.tipoCarroceria,
    placaCarroceira: schema =>
      schema.model.placaCarroceira?.toUpperCase() ?? '',
    antt: schema => schema.model.antt?.toUpperCase() ?? '',
    cnh: schema => schema.model.cnh?.toUpperCase() ?? '',
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    idResponsavelCriadorFk: schema => schema.model.idResponsavelCriadorFk,
    nomeIndicador: schema => schema.model.nomeIndicador?.toUpperCase() ?? '',
    cep: schema => schema.model.endereco?.cep || '',
    logradouro: schema => schema.model.endereco?.logradouro || '',
    bairro: schema => schema.model.endereco?.bairro || '',
    cidade: schema => schema.model.endereco?.cidade || '',
    uf: schema => schema.model.endereco?.uf || '',
    versao: schema => schema.model.versao,
    marcaAparelho: schema => schema.model.marcaAparelho,
    modeloAparelho: schema => schema.model.modeloAparelho,
    nomeResponsavelUltimaAlteracao: schema =>
      schema.model.motoristaAlteracaoInfo?.nomeResponsavelUltimaAlteracao?.toUpperCase() ??
      '',
    dataUltimaModificacao: schema =>
      schema.model.motoristaAlteracaoInfo?.dataUltimaModificacao
        ? Helper.datetime(
            schema.model.motoristaAlteracaoInfo?.dataUltimaModificacao
          )
        : '',
  }
}
